import { isNumber } from "lodash";
import { Icon } from "react-migration/components/Icon";

interface AttributeComparisonTextSummaryProps {
  value?: number;
  label?: string;
  comparativeValue?: number | string | null;
  comparativeDisplayName?: string;
}
export function AttributeComparisonTextSummary({
  value,
  label,
  comparativeValue,
  comparativeDisplayName,
}: AttributeComparisonTextSummaryProps) {
  if (!isNumber(value) || !label) return null;

  return (
    <div className="flex gap-x-1 items-center text-sm text-neutral-800 overflow-hidden">
      {!isNumber(comparativeValue) || !comparativeDisplayName ? (
        <span className="truncate">
          <span className="font-medium">{label}</span> for this area
        </span>
      ) : value > comparativeValue ? (
        <>
          <Icon size="xs" icon="icon-lt-arrow-up-line" />
          <span className="truncate">
            <span className="font-medium">{label}</span> higher than {comparativeDisplayName}
          </span>
        </>
      ) : value === comparativeValue ? (
        <>
          <Icon size="xs" icon="icon-lt-equal-line" />
          <span className="truncate">
            <span className="font-medium">{label}</span> equal to {comparativeDisplayName}
          </span>
        </>
      ) : value < comparativeValue ? (
        <>
          <Icon size="xs" icon="icon-lt-arrow-up-line" extraClasses={"rotate-180"} />
          <span className="truncate">
            <span className="font-medium">{label}</span> lower than {comparativeDisplayName}
          </span>
        </>
      ) : null}
    </div>
  );
}
